import {baseApi} from 'core/redux/store/api';
import {API_VERSION} from 'core/helpers/env';
import {IWishListArticlesData} from 'modules/wish-list/models';

export const wishListApiService = baseApi.injectEndpoints({
    overrideExisting: true,
    // eslint-disable-next-line sort-keys
    endpoints: (builder) => ({
        addToWishList: builder.mutation({
            invalidatesTags: ['WishList'],
            query: ({id}) => ({
                body: {
                    masterArticle: id,
                },
                method: 'POST',
                url: `${API_VERSION}/wishlist`,
            }),
        }),
        getWishListArticles: builder.query<IWishListArticlesData, void>({
            providesTags: ['WishList'],
            query: () => `${API_VERSION}/wishlist/list`,
            transformResponse: (response: {data: IWishListArticlesData}) => response.data,
        }),
        removeFromWishList: builder.mutation({
            invalidatesTags: ['WishList'],
            query: ({id}) => ({
                method: 'DELETE',
                url: `${API_VERSION}/wishlist/${id}`,
            }),
        }),
    }),
});

export const {useGetWishListArticlesQuery, useAddToWishListMutation, useRemoveFromWishListMutation} =
    wishListApiService;
